// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-social app-social {
  float: right;
  right: 10px;
  margin-right: 0;
  margin-left: 15px;
}

img.wp-smiley, img.emoji {
  display: inline !important;
  border: none !important;
  box-shadow: none !important;
  height: 1em !important;
  width: 1em !important;
  margin: 0 0.07em !important;
  vertical-align: -0.1em !important;
  background: none !important;
  padding: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/footer/footer.component.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;EAC3B,qBAAqB;AACvB","sourcesContent":[".footer-social app-social {\r\n  float: right;\r\n  right: 10px;\r\n  margin-right: 0;\r\n  margin-left: 15px;\r\n}\r\n\r\nimg.wp-smiley, img.emoji {\r\n  display: inline !important;\r\n  border: none !important;\r\n  box-shadow: none !important;\r\n  height: 1em !important;\r\n  width: 1em !important;\r\n  margin: 0 0.07em !important;\r\n  vertical-align: -0.1em !important;\r\n  background: none !important;\r\n  padding: 0 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
